import { createClient } from './supabase/client';
import { TABLES } from './tables';
import { Project, ProjectFormData } from './types';

export async function fetchProjects(): Promise<Project[]> {
  // 每次调用时创建新的客户端实例，确保使用当前用户的会话
  const supabase = createClient();
  
  const { data, error } = await supabase
    .from(TABLES.projects)
    .select('*')
    .order('date', { ascending: false });

  if (error) {
    console.error('Error fetching projects:', error);
    console.error('Error details:', {
      code: error.code,
      message: error.message,
      details: error.details,
      hint: error.hint,
    });
    throw error;
  }

  return data || [];
}

export async function fetchProject(id: string): Promise<Project | null> {
  const supabase = createClient();
  
  const { data, error } = await supabase
    .from(TABLES.projects)
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    console.error('Error fetching project:', error);
    return null;
  }

  return data;
}

export async function createProject(input: ProjectFormData): Promise<Project> {
  const supabase = createClient();
  
  // 获取当前用户并自动设置 user_id
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) {
    throw new Error('User must be authenticated to create projects');
  }
  
  const { data, error } = await supabase
    .from(TABLES.projects)
    .insert({
      ...input,
      user_id: user.id,  // 自动设置创建者
    })
    .select()
    .single();

  if (error) {
    console.error('Error creating project:', error);
    throw error;
  }

  return data;
}

export async function updateProject(
  id: string,
  updates: Partial<ProjectFormData>
): Promise<Project> {
  const supabase = createClient();
  
  const { data, error } = await supabase
    .from(TABLES.projects)
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    console.error('Error updating project:', error);
    throw error;
  }

  return data;
}

export async function deleteProject(id: string): Promise<void> {
  const supabase = createClient();
  
  const { error } = await supabase
    .from(TABLES.projects)
    .delete()
    .eq('id', id);

  if (error) {
    console.error('Error deleting project:', error);
    throw error;
  }
}

